import React, { useState, useEffect } from 'react'
import { VendorContext } from '../../../contexts/vendorContext'
import { VendorUser } from '../../../models/VendorUser'
import { StoreKey } from '../../../config/enums'
import { Vendor } from '../../../models/Vendor'

const VendorContextProvider: React.FC = ({ children }) => {
  const [profile, setProfile] = useState<VendorUser | null>(() => {
    const data = localStorage.getItem(StoreKey.vendorProfile)
    if (data !== null) {
      return JSON.parse(data) as VendorUser
    }
    return null
  })

  const [companyProfile, setCompanyProfile] = useState<Vendor | null>(() => {
    const data = localStorage.getItem(StoreKey.companyProfile)
    if (data !== null) {
      return JSON.parse(data) as Vendor
    }
    return null
  })

  useEffect(() => {
    localStorage.setItem(StoreKey.vendorProfile, JSON.stringify(profile))
  }, [profile])

  useEffect(() => {
    localStorage.setItem(
      StoreKey.companyProfile,
      JSON.stringify(companyProfile)
    )
  }, [companyProfile])

  return (
    <VendorContext.Provider
      value={{
        profile,
        setProfile,
        companyProfile,
        setCompanyProfile
      }}
    >
      {children}
    </VendorContext.Provider>
  )
}

export default VendorContextProvider
